import IA from "./ia";
import HistoriaIA from "./historia_ia";
import MachineLearning from "./machine_learning";
import DeepLearning from "./deep_learning";
import IaGenerativa from "./ia_generativa";
import HPC from "./hpc";

export const SUBMENU_IA = {
  titulo: "Inteligencia Artificial",
  id: "submenu-ia",
  modulos: [
    { path: "historia_ia", label: "Historia de la IA", Component: HistoriaIA },
    { path: "ia", label: "IA", Component: IA },
    { path: "machine_learning", label: "Machine Learning", Component: MachineLearning },
    { path: "deep_learning", label: "Deep Learning", Component: DeepLearning },
    { path: "ia_generativa", label: "IA Generativa", Component: IaGenerativa },
  ],
};

export const SUBMENU_HPC = {
  titulo: "Cómputo de Alto Desempeño",
  id: "submenu-hpc",
  modulos: [{ path: "hpc", label: "HPC", Component: HPC }],
};

export const SUBMENUS_FORMACION = [SUBMENU_IA, SUBMENU_HPC];

export const MODULOS_FORMACION = SUBMENUS_FORMACION.flatMap((submenu) => submenu.modulos);
